/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Exactly one of these fields should be set.  Consumers of this type must
 * treat an empty object as if it has an unknown value.
 * @export
 * @interface V1ClaimSource
 */
export interface V1ClaimSource {
    /**
     * ResourceClaimName is the name of a ResourceClaim object in the same
     * namespace as this pod.
     * @type {string}
     * @memberof V1ClaimSource
     */
    resourceClaimName?: string;
    /**
     * ResourceClaimTemplateName is the name of a ResourceClaimTemplate
     * object in the same namespace as this pod.
     * 
     * The template will be used to create a new ResourceClaim, which will
     * be bound to this pod. When this pod is deleted, the ResourceClaim
     * will also be deleted. The pod name and resource name, along with a
     * generated component, will be used to form a unique name for the
     * ResourceClaim, which will be recorded in pod.status.resourceClaimStatuses.
     * 
     * This field is immutable and no changes will be made to the
     * corresponding ResourceClaim by the control plane after creating the
     * ResourceClaim.
     * @type {string}
     * @memberof V1ClaimSource
     */
    resourceClaimTemplateName?: string;
}

export function V1ClaimSourceFromJSON(json: any): V1ClaimSource {
    return V1ClaimSourceFromJSONTyped(json, false);
}

export function V1ClaimSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ClaimSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resourceClaimName': !exists(json, 'resourceClaimName') ? undefined : json['resourceClaimName'],
        'resourceClaimTemplateName': !exists(json, 'resourceClaimTemplateName') ? undefined : json['resourceClaimTemplateName'],
    };
}

export function V1ClaimSourceToJSON(value?: V1ClaimSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resourceClaimName': value.resourceClaimName,
        'resourceClaimTemplateName': value.resourceClaimTemplateName,
    };
}

